import styles from './Alert.module.css'

export type AlertSeverity = 'error' | 'success' | 'info' | 'warning'

interface AlertProps {
  children: React.ReactNode
  severity?: AlertSeverity
  className?: string
}

export default function Alert({ children, severity = 'info', className }: AlertProps) {
  return (
    <div className={[styles.alert, styles[severity], className].filter(Boolean).join(' ')}>
      {children}
    </div>
  )
}
